import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { showPriceCSS } from "./ShowPrice.css";
import { InputText } from "primereact/inputtext";

import { Button } from "primereact/button";
import { set, useForm } from "react-hook-form";
import { leftVector } from "../../../../Assets/Images";
import { SliderPlazo } from "../../../../Components";
import { formatNumber } from "../../../../Utils";
import { scrollToElement } from "../../../Landing/functions";
import { downloadPDF } from "../../functions/downloadPDF";
import { url } from "../../../../env";
import axios from "axios";
import { PDFViewer } from "@react-pdf/renderer";
import { PDFComponent } from "../../PDFComponent/PDFComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Register } from "../../../Register/Register";
import ModalGral from "../../../../Components/ModalGral/ModalGral";
import { AuthContext } from "../../../../Context/AuthContext";
import { useResponsiveDialog } from "../../../../Context/ResponsiveDialogContext";
import { motion } from "framer-motion";

function ShowPrice({ state, setState, setStep, isShared, isSharedCode, onBudgetUpdated, budgetUpdated, setBudgetUpdated, setStepNum, isCotizador3 = false }) {
  const navigate = useNavigate();
  const { secret } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  let id = params.get("id");

  const { setIdUser } = useContext(AuthContext);
  const { containerWidth } = useResponsiveDialog();

  const [selectedPlazo, setSelectedPlazo] = useState(null);




  useEffect(() => {
    if (secret) {
      setTimeout(async () => {
        setState((prev) => ({
          ...prev,
          budget_secret: secret,
          budget_id: id,
          loader: false,
        }));
      }, 4000);
    }
  }, [secret]);


  const [cards, setCards] = useState({
    one: false,
    two: false,
    three: false,
  });




  const [resumen, setResumen] = useState({
    "Estimado Sr.(a)": "",
    Descripción: " - ",
    "Precio del Vehículo": " - ",
    Accesorios: " - ",
    "Precio Total": " - ",
    Plazo: " - ",
    "Suma a Asegurar": " - ",
    Enganche: " - ",
    "Comisión por Apertura": " - ",
    "Seguro Multianual": " - ",
    "Gastos de Originación": "-",
    "Total Pago Inicial": "-",
    "Importe del Vehículo a Financiar": "-",
    "Pago Mensual Base (incl IVA)": "-",
    "Servicios Mensuales (incl IVA)": "-",
    "Seguro (s/IVA)": "-",
    "GPS (s/IVA)": "-",
    "Gestorías (s/IVA)": "-",

    "Pago Mensual Total (incl IVA)": "-",
    'isPure': false,

    // "Estimado Sr.(a)": "Davidsonn",
    // "Descripción": "Nuevo BMW X3 M401",
    // "Precio del Vehículo": "1,687,200",
    // "Accesorios": "30,000",
    // "Precio Total": "1,687,200",
    // "Plazo": "  36",
    // "Suma a Asegurar": "  1,687,200 ",
    // "Enganche": " 30,000 ",
    // "Comisión por Apertura": "30,000 ",
    // "Seguro Multianual": "   70,000",
    // "Gastos de Originación": " 30,000 ",
    // "Total Pago Inicial": " 30,000 ",
    // "Importe del Vehículo a Financiar": "1,387,200 ",
    // "Pago Mensual Base (incl IVA)": " 20,000",
    // "Servicios Mensuales (incl IVA)": "2,000",
    // "Seguro (s/IVA)": " 3,401",
    // "GPS (s/IVA)": "550",
    // "Gestorías (s/IVA)": "340 ",
    // "Pago Mensual Total (incl IVA)": "30,000"
  });


  const [detalle, setDetalle] = useState([]);
  // manejar modal de confirmación mail
  const [showModal, setShowModal] = useState(false);

  const defaultValues = {
    number: null,
    email: null,
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
    setValue,
  } = useForm({ defaultValues });


  const [isError, setIsError] = useState(false);
  const [msgError, setMsgError] = useState("");

  const submit = (data, type) => {
    let email = data.email;
    let phone = data.number;

    setState((prev) => {
      return {
        ...prev,
        loader: true,
      };
    });

    try {
      setIsError(false);
      setMsgError("");
      // downloadPDF(resumen, detalle, allDetalleState);
      // debugger
      let currentPlazoIndex = getCurrentPlazoIndex();
      let newIgnorePosition = state.pdfPlazo.findIndex(
        (item) => item.ignore === true
      );
      let newIndex = allDetalleState.find((item) => item.selected === true);

      if (newInsurancesCards[0] == 36 && newInsurancesCards[1] == 48 && newInsurancesCards[2] == 60) {
        currentPlazoIndex = currentPlazoIndex + 1;
      }

      let updated_insurance_id =
        state.rodac.plazosInsurancesFiltered[currentPlazoIndex];
      let budget_id = state.budget_id;
      let budget_secret = state.budget_secret;

      state.next.push(state.resumen);

      let newResumen = state.next.find(item => parseInt(item.Plazo.split(" ")[0]) === selectedPlazo);

      if (!newResumen) {
        newResumen = state.next.find(item => {
          let plazoNum = item.Plazo.split(" ")[0];
          return parseInt(plazoNum) === selectedPlazo;
        });
      }

      let newAllDetalleState = selectedPlazo ? allDetalleState.map(item => {
        if (item.plazo === selectedPlazo) {
          item.selected = true;
        } else {
          item.selected = false;
        }
        return item;
      }) : allDetalleState;

      downloadPDF(selectedPlazo ? newResumen : resumen, detalle, selectedPlazo ? newAllDetalleState : allDetalleState);
      /*  TODO: Descomentar este axios */
      axios
        .post(`${url}/updateBudget`, {
          budget_id,
          budget_secret,
          insurance_id: updated_insurance_id,
          email,
          phone,
          type,
        })
        .then((res) => {
          if (type === 1) {
            // navigate('/home')
            setShowModal(true);
            onBudgetUpdated?.(); // Notify parent that budget has been updated
          } else setStep("exit");
        })
        .catch((e) => {
          // Verificar si existe e.response y e.response.data
          const errorMessage = (e?.response?.data || "Vuele a intentarlo");
          // Establecer el estado en caso de error
          setIsError(true);
          setMsgError(errorMessage);
          setShowModal(true);

          // Registrar el error completo en la consola para depuración
          console.error("Error details:", e);
        }).finally(() => {
          setState((prev) => {
            return {
              ...prev,
              loader: false,
            };
          });
        });
    } catch (error) {
      console.log(error);
      //setStep(3)
    }
  };

  function previousStep() {
    setStep((prev) => prev - 1);
  }

  function getCurrentPlazoIndex() {
    try {
      return Object.values(cards).indexOf(true);
    } catch (error) {
      return 0;
    }
  }

  function selectPrevPlazo() {
    if (cards.two) setCards({ one: true, two: false, three: false });
    else if (cards.three) setCards({ one: false, two: true, three: false });
  }

  function selectNextPlazo() {
    if (cards.one) setCards({ one: false, two: true, three: false });
    else if (cards.two) setCards({ one: false, two: false, three: true });
  }

  const [newInsurancesCards, setNewInsurancesCards] = useState([]);

  useEffect(() => {

    setIdUser(id);

    scrollToElement("HeaderCotizador");

    const insur = state.pdfPlazo ? state.pdfPlazo.map((item) => item.plazo) : [];
    const insurCard = state.rodac.payment_configurations
      .map((item) => {
        return insur.includes(parseInt(item.configuration)) ? item.id : null;
      })
      .filter(item => item !== null);

    if (isCotizador3) {
      const selectedIndex = state.pdfPlazo?.findIndex((item) => item.selected === true) ?? -1;
      const selectedCardIndex = selectedIndex >= 0 ? selectedIndex : 0;

      setSelectedPlazo(insur[selectedCardIndex]);
      setCards({
        one: selectedCardIndex === 0,
        two: selectedCardIndex === 1,
        three: selectedCardIndex === 2,
      });
      return;
    }

    let two = state.rodac.payment_configuration_id == 15 ? true : insurCard[1] === state.rodac.payment_configuration_id
    setCards({
      one: insurCard[0] === state.rodac.payment_configuration_id,
      two: state.rodac.payment_configuration_id == 15 ? true : insurCard[1] === state.rodac.payment_configuration_id,
      three: state.rodac.payment_configuration_id == 16 ? true : (insurCard[2] === state.rodac.payment_configuration_id && !two),
    });

  }, []);



  const [allDetalleState, setAllDetalleState] = useState([
    {
      plazo: 24,
      section2: {
        "Gasto Inicial Arrendamiento": ["38,793.10", "45,000.00"],
        "Comisión Apertura": ["6,594.83", "7,650.00"],
        "Contraprestación": ["6,000.00", "6,960.00"],
        "Gastos Administrativos": ["4,373.22", "5,072.93"],
        "Seguro Automotriz": ["2,000.00", "2,320.00"],
        // Añade más datos según sea necesario
      },
      section3: {
        "Contraprestación": ["6,000.00", "6,960.00"],
        "Gastos x": ["4,373.22", "5,072.93"],
        "Seguro Automotriz": ["2,000.00", "2,320.00"],
        "Administracion Seguro Automotriz": ["500.00", "580.00"],
        "Servicio Geolocalización": ["1,000.00", "1,160.00"],
        // Añade más datos según sea necesario
      },
    },
    // Puedes agregar más objetos según sea necesario
  ]);

  useEffect(() => {
    try {
      const insur = state.pdfPlazo
        .map(item => item.plazo);
      let newData = state.next.filter(item => item.ignore === false);
      let allResumen = isCotizador3 ? newData : [state.resumen, newData[1], newData[2]];
      let currentPlazoIndex = Object.values(cards).indexOf(true);
      let resumenIndex = allResumen.findIndex((obj) =>
        obj["Plazo"].includes(insur[currentPlazoIndex])
      );

      let allDetalle = isCotizador3 ? state.nextDetalle : [
        state.detalle,
        state.nextDetalle[0],
        state.nextDetalle[1],
      ];

      setResumen({
        ...allResumen[resumenIndex],
        pdfPlazo: state.pdfPlazo,
      });

      setNewInsurancesCards(insur);
      setAllDetalleState(state.pdfPlazo);

      setDetalle(allDetalle[resumenIndex]);

    } catch (error) {
      //console.log(error)
    }
  }, [cards]);


  // Redirigir a Register si no hay secret
  if (!secret && (isShared || isSharedCode)) {
    return <Register secret={secret} setState={setState} id={id} setStep={setStep} />;
  }


  let selectedCard = () => {
    if (cards.one) {
      return 1
    } else if (cards.two) {
      return 2
    } else {
      return 3
    }
  }
  const selected = selectedCard();




  const gastoInicialArrendamiento = resumen?.pdfPlazo?.[selected - 1]?.section2?.['Gasto Inicial Arrendamiento']?.[1] ?? 0;
  const enganche = resumen?.pdfPlazo?.[selected - 1]?.section2?.['Enganche']?.[1] ?? 0;

  const totalPagoInicial = resumen?.pdfPlazo?.[selected - 1]?.section2?.['Total Pago Inicial (incl IVA)']?.[1] ?? 0;
  return !secret || isShared ? (
    <Dialog
      visible={true}
      modal={true}
      dismissableMask={true}
      closable={!budgetUpdated}
      resizable={true}
      draggable={true}
      /* fullScreen={true} */
      className="custom-cotizador-dialog"
      onHide={() => {
        if (!budgetUpdated) {
          setStepNum(1);
          setBudgetUpdated(false);
        }
      }}
      style={{
        maxWidth: "1100px",
        border: "1px solid #22ec9b79",
        boxShadow: "0 0 15px 3px hsla(101, 20%, 43%, 0.25)",
        borderRadius: "24px",
        overflow: "hidden",
      }}
      contentStyle={{
        maxHeight: "81vh",
        overflow: "auto",
        padding: "0",
      }}
      showHeader={false}
      breakpoints={{ "1200px": "90vw", "960px": "95vw", "641px": "98vw" }}
    >
      <div css={showPriceCSS()}>
        {/* Previsualizar PDF */}
        {/* <div className="PreviewPDF">
        <PDFViewer>
          <PDFComponent resumen={resumen} detalle={detalle} allDetalleState={allDetalleState} />
        </PDFViewer>
      </div> */}
        {showModal && (
          <ModalGral showModal={showModal} setShowModal={setShowModal} isError={isError} data={msgError} />
        )}
        <div className="flex flex-column align-items-center ">
          <div className="font-semibold title pb-3 text-center">
            Cotización de Arrendamiento Peicar
          </div>
          <div className="mainText">
            Estimado Sr(a): <span className="font-bold">{state.rodac.name}</span>
          </div>
          <div className="mainText pb-3">
            {state.rodac.car_status_select?.status} /{" "}
            <span className="font-bold">
              {state.rodac.description_select?.description} -{" "}
              {state.rodac?.model_id}
            </span>
          </div>
          <div className="dataText flex gap-2">
            <div>
              Precio del vehiculo /{" "}
              <span className="font-semibold">
                ${formatNumber(state.rodac?.amount)}
              </span>
            </div>
            {(gastoInicialArrendamiento !== 0 || enganche !== 0) && (
              <>
                <div className="Hyphen">-</div>
                <div>
                  {gastoInicialArrendamiento !== 0 ? 'Gasto inicial arrendamiento' : 'Enganche'} /{" "}
                  <span className="font-semibold">
                    ${gastoInicialArrendamiento !== 0 ? gastoInicialArrendamiento : enganche}
                  </span>
                </div>
              </>
            )}

            <div className="Hyphen">-</div>
            <div>
              A financiar /{" "}
              <span className="font-semibold">
                ${resumen && resumen["Importe del Vehículo a Financiar"]}
              </span>
            </div>
            <div className="Hyphen">-</div>
            <div>
              Pago inicial /{" "}
              <span className="font-semibold">
                ${resumen && totalPagoInicial}
              </span>
            </div>
          </div>
        </div>
        <div className="PlazosContainer">

          {/* card one */}
          <div
            className={
              "CardContainer LeftCardContainer " +
              `${!cards.one ? "InactiveCardContainer" : ""}`
            }
          >
            <motion.div
              className={"Card " + `${cards.one ? "active" : ""}`}
              onClick={() => {
                setSelectedPlazo(newInsurancesCards[0]);
                setCards({ one: true, two: false, three: false });
              }}
              whileHover={{ scale: 1.06, y: -3 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: 'spring', stiffness: 350, damping: 22 }}
            >
              <div className="contentCard">
                <div className="textContent"></div>
                <div className="months">
                  {newInsurancesCards && newInsurancesCards[0]}
                </div>
                <div className="text">plazo en meses</div>
                {resumen?.pdfPlazo?.[0]?.residual_capped && (
                  <div className="CappedChip">
                    Residual ajustado a {resumen.pdfPlazo[0].residual_percentage}%
                  </div>
                )}
              </div>
              <div className="footerCard">
                <div className="textContent">
                  <div className="price">
                    ${resumen?.pdfPlazo?.[0]?.section3?.['Total Pago Mensual (incl IVA)']?.[1] || resumen?.pdfPlazo?.[0]?.section3?.['Pago Mensual Total (incl IVA)']?.[1] || 0}
                  </div>
                  <div className="text">
                    pago mensual
                  </div>
                </div>
              </div>
            </motion.div>
            <div className="shadowCard" />
          </div>

          {/* card two */}
          <div
            className={
              "CardContainer " + `${!cards.two ? "InactiveCardContainer" : ""}`
            }
          >
            <motion.div
              className={"Card " + `${cards.two ? "active" : ""}`}
              onClick={() => {
                setSelectedPlazo(newInsurancesCards[1]);
                setCards({ one: false, two: true, three: false });
              }}
              whileHover={{ scale: 1.06, y: -3 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: 'spring', stiffness: 350, damping: 22 }}
            >
              <div className="contentCard">
                <div className="months">
                  {newInsurancesCards && newInsurancesCards[1]}
                </div>
                <div className="text">plazo en meses</div>
                {resumen?.pdfPlazo?.[1]?.residual_capped && (
                  <div className="CappedChip">
                    Residual ajustado a {resumen.pdfPlazo[1].residual_percentage}%
                  </div>
                )}
              </div>
              <div className="footerCard">
                <div className="textContent">
                  <div className="price">
                    ${resumen?.pdfPlazo?.[1]?.section3?.['Total Pago Mensual (incl IVA)']?.[1] || resumen?.pdfPlazo?.[1]?.section3?.['Pago Mensual Total (incl IVA)']?.[1] || 0}
                  </div>
                  <div className="text">
                    pago mensual
                  </div>
                </div>
              </div>
            </motion.div>
            <div className="shadowCard" />
          </div>

          {/* card three */}
          <div
            className={
              "CardContainer RightCardContainer " +
              `${!cards.three ? "InactiveCardContainer" : ""}`
            }
          >
            <motion.div
              className={"Card " + `${cards.three ? "active" : ""}`}
              onClick={() => {
                setSelectedPlazo(newInsurancesCards[2]);
                setCards({ one: false, two: false, three: true });
              }}
              whileHover={{ scale: 1.06, y: -3 }}
              whileTap={{ scale: 0.97 }}
              transition={{ type: 'spring', stiffness: 350, damping: 22 }}
            >
              <div className="contentCard">
                <div className="months">
                  {newInsurancesCards && newInsurancesCards[2]}
                </div>
                <div className="text">plazo en meses</div>
                {resumen?.pdfPlazo?.[2]?.residual_capped && (
                  <div className="CappedChip">
                    Residual ajustado a {resumen.pdfPlazo[2].residual_percentage}%
                  </div>
                )}
              </div>
              <div className="footerCard">
                <div className="textContent">
                  <div className="price">
                    ${resumen?.pdfPlazo?.[2]?.section3?.['Total Pago Mensual (incl IVA)']?.[1] || resumen?.pdfPlazo?.[2]?.section3?.['Pago Mensual Total (incl IVA)']?.[1] || 0}
                  </div>
                  <div className="text">
                    pago mensual
                  </div>
                </div>
              </div>
            </motion.div>
            <div className="shadowCard" />
          </div>
        </div>

        <div className="PlazosNavigator">
          <div className="Left NavButton" onClick={selectPrevPlazo}>
            {state.plazos?.parray &&
              state.plazos.parray[getCurrentPlazoIndex() - 1] && (
                <>
                  <span>&lt;&lt;&nbsp;</span>
                  <span>
                    {state.plazos.parray[getCurrentPlazoIndex() - 1]} meses
                  </span>
                </>
              )}
          </div>

          <div className="Right NavButton" onClick={selectNextPlazo}>
            {state.plazos?.parray &&
              state.plazos.parray[getCurrentPlazoIndex() + 1] && (
                <>
                  <span>
                    {state.plazos.parray[getCurrentPlazoIndex() + 1]} meses
                  </span>
                  <span>&nbsp;&gt;&gt;</span>
                </>
              )}
          </div>
        </div>

        {state.rodac.plazosInsurancesChanged.length > 0 &&
          state.rodac.plazosInsurancesChanged[
          Object.values(cards).indexOf(true)
          ] && (
            <section className="Note">
              <span>Nota: la aseguradora cambia en el plazo seleccionado</span>
            </section>
          )}

        <div className="flex flex-column align-items-center w-full relative">
          <img src={leftVector} className="absolute left-0 BgElement" />
          <div
            className="backgroundLine absolute right-0"
            style={{ top: "175px" }}
          />
          <div
            className="backgroundLine absolute bottom-50"
            style={{ right: "140px" }}
          />
          <div
            className="backgroundLine absolute"
            style={{ right: "48px", bottom: "155px" }}
          />
          {/* <div className='absolute right-0' style={{ right: "285px" }}>
                    <div className='relative'>
                        <div className='backgroundLine absolute' />
                        <div className='backgroundLine absolute' />
                        <div className='backgroundLine absolute' />
                    </div>
                </div> */}
          <div className="flex flex-column align-items-center FormContainer">
            <div className="mainText text-center FormTitleContainer pb-3">
              Ingresa los siguientes datos para obtener tu cotización desglosada.
            </div>
            <form
              onSubmit={handleSubmit((data) => submit(data, 1))}
              className="grid"
            >
              <div className="col-12 px-2 py-1">
                <InputText
                  maxLength={40}
                  {...register("email", {
                    required: true,
                    pattern:
                      /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/,
                    maxLength: 40,
                  })}
                  placeholder="Correo electrónico"
                  className={
                    "EmailInput w-full TextInput " +
                    `${errors["email"] ? "p-invalid" : ""}`
                  }
                />
              </div>
              <div className="col-12 px-2 py-1 pb-2">
                <InputText
                  keyfilter={"num"}
                  {...register("number", {
                    required: true,
                    pattern:
                      /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?[\d{1,9}\s]$/,
                    maxLength: 10,
                  })}
                  maxLength={10}
                  placeholder="Teléfono (WhatsApp)"
                  className={
                    "w-full TextInput " + `${errors["number"] ? "p-invalid" : ""}`
                  }
                />
              </div>
              <div className="col-6 p-2 ButtonContainer">
                <Button
                  type="button"
                  label="Volver a cotizar"
                  className="w-full Blue Button py-3"
                  onClick={previousStep}
                />
              </div>
              <div className="col-6 p-2 ButtonContainer">
                <Button
                  label="Recibir cotización y continuar"
                  className="w-full Green Button py-3"
                  loading={state.loader}
                  disabled={state.loader}
                />
              </div>
              <div className="col-12 p-2 ButtonContainer">
                <button
                  type="button"
                  data="Quiero que me contacte un asesor"
                  className="Button w-full GradientLeft"
                  onClick={handleSubmit((data) => submit(data, 2))}
                />
              </div>
              <div className="col-12 flex justify-content-center pt-6">
                <div
                  className="shadowCard "
                  style={{ height: "2rem", width: "80%" }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </Dialog>
  ) : (
    <Register secret={secret} setState={setState} id={id} setStep={setStep} />
  );
}

export { ShowPrice };
